import {OwcList, OwcTypography} from '@one/react';
import React from 'react';
import '../../styles.scss';
import DataUseListItem from "./DataUseListItem.js";

/**
 * Renders a list control for data uses
 *
 * @copyright Roche 2025
 * @author Geoffroy Maillol
 */
class DataUseList extends React.Component {

  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {
    return (
      <div style={{display:"flex", flexDirection:"column"}}>
      <OwcList size={this.props.size}>
        {this.props.hideTitle===true
          ? <></>
          : <div slot="title">{this.props.title}</div>
        }
        {this.props.dataUseList.map(dataUse => (
          <DataUseListItem
            dataUse={dataUse}
            showActionIcon={this.props.showActionIcon}
            actionIcon={this.props.actionIcon}
            actionTooltip={this.props.actionTooltip}
            keyPrefix={this.props.keyPrefix}
            onAction={this.props.onAction}
          />
        ))}
      </OwcList>
      {this.props.dataUseList.length === 0
        ? <OwcTypography style={{marginLeft:"1em"}}>No data use</OwcTypography>
        : ""
      }
      </div>
    );
  }

}

DataUseList.defaultProps = {
  dataUseList: [],
  hideTitle: false,
  title: "Selected Data Uses",
  size: "medium",
  showActionIcon: true,
  actionIcon: "circle_clear",
  actionTooltip: "Remove this data use from the selection",
  keyPrefix: "DataUseListItem",
  onAction: ()=>{},
}

export default DataUseList;
